import {
  ChecklistDTO,
  DigitalSignStartDTO,
  PositionDTO,
  SurveyDTO
} from '@api/models/';
import { OutputAdapterService } from '@api/services/output-adapter/output-adapter.service';
import { Injectable } from '@angular/core';
import { isValidUrl } from '@core/utils';

@Injectable({
  providedIn: 'root'
})
export class OutputAdapterCustomService extends OutputAdapterService {
  constructor() {
    super();
  }

  getPosition(output: any): PositionDTO {
    output = this.cleanPayload(output);

    output.tuple = [output.product];

    return output;
  }

  getPositionFull(output: any): PositionDTO {
    output = this.cleanPayload(output);

    output.tuple = [output.product];

    return output;
  }

  getSurvey(output: any): SurveyDTO[] {
    return (output && output.surveys) || [];
  }

  getChecklist(output: any): ChecklistDTO {
    return this.cleanPayload(output);
  }

  postSignStart(output: any): DigitalSignStartDTO {
    if (!isValidUrl(output.providerUrl)) {
      output.completed = true;
    }

    return output;
  }
}
